var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 7.4375V24.3125C30 25.8652 28.7402 27.125 27.1875 27.125H2.8125C1.25977 27.125 0 25.8652 0 24.3125V7.4375C0 5.88477 1.25977 4.625 2.8125 4.625H7.96875L8.68945 2.69727C9.09961 1.60156 10.1484 0.875 11.3203 0.875H18.6738C19.8457 0.875 20.8945 1.60156 21.3047 2.69727L22.0312 4.625H27.1875C28.7402 4.625 30 5.88477 30 7.4375ZM22.0312 15.875C22.0312 11.9961 18.8789 8.84375 15 8.84375C11.1211 8.84375 7.96875 11.9961 7.96875 15.875C7.96875 19.7539 11.1211 22.9062 15 22.9062C18.8789 22.9062 22.0312 19.7539 22.0312 15.875ZM20.1562 15.875C20.1562 18.7168 17.8418 21.0312 15 21.0312C12.1582 21.0312 9.84375 18.7168 9.84375 15.875C9.84375 13.0332 12.1582 10.7188 15 10.7188C17.8418 10.7188 20.1562 13.0332 20.1562 15.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f7e007a13379d7e4d8c49b8af4780123.svg";
export { ForwardRef as ReactComponent };